module.exports = __webpack_public_path__ + "img/rocket-speed.0d84e483.png";